import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SupplierInteractiveScheduleComponent } from './supplier-interactive-schedule.component';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { InteractiveScheduleModule } from '../interactive-schedule.module';
import { PendingChangesGuard } from '../../../guards/pending-changes.guard';
import { ConfirmationService } from 'primeng';
import { RedirectTermConditionGuard } from 'src/app/guards/redirect-term-condition.guard';

const routes: Routes = [
  {
    path: '',
    component: SupplierInteractiveScheduleComponent,
    data: { title: 'Interactive Schedule' },
    canDeactivate: [PendingChangesGuard],
    canActivate: [RedirectTermConditionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierInteractiveScheduleRoutingModule {}

@NgModule({
  imports: [
    SupplierInteractiveScheduleRoutingModule,
    InteractiveScheduleModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  providers: [PendingChangesGuard, ConfirmationService],
  declarations: [SupplierInteractiveScheduleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierInteractiveScheduleModule {}
